module.exports = __webpack_public_path__ + "img/bu-dotted2.c5c192be.svg";